import type { B2BFormat } from "./b2b/stage";
import type { B2CFormat } from "./b2c/stage";
import type { MerchantFormat } from "./merchant/stage";

/**
 * Every rendered composition, as plain data. `Root.tsx` registers the
 * compositions from these lists, and the render pipeline (`server/lib/`,
 * used by the scripts and the video server) enumerates its outputs from
 * them, so a new format or language shows up in both at once. The
 * Instagram reels have their own list, `reels/catalog.ts`.
 *
 * No React or Remotion import (types only): Bun loads this file outside
 * the bundle.
 */

export const LANGS = ["fr", "en"] as const;
export type Lang = (typeof LANGS)[number];

/** B2C ambassador video. `""` (square) is the landing embed and the master. */
export const B2C_VARIANTS = [
  { suffix: "", format: "square" },
  { suffix: "-Portrait", format: "portrait" },
  { suffix: "-AppStore", format: "appstore" },
  { suffix: "-Landscape", format: "landscape" },
] as const satisfies readonly { suffix: string; format: B2CFormat }[];

/** B2B partner video. `""` (landscape) is the partner page embed and the master. */
export const B2B_VARIANTS = [
  { suffix: "", format: "landscape" },
  { suffix: "-Feed", format: "feed" },
  { suffix: "-Square", format: "square" },
] as const satisfies readonly { suffix: string; format: B2BFormat }[];

/** B2B poster / LinkedIn thumbnail: the end of the hook. */
export const B2B_POSTER_FRAME = 106;

/** Per-merchant commercial. Story (9:16) is the master. */
export const MERCHANT_VARIANTS = [
  { suffix: "Story", format: "story" },
  { suffix: "Feed", format: "feed" },
  { suffix: "Square", format: "square" },
  { suffix: "Wide", format: "wide" },
] as const satisfies readonly { suffix: string; format: MerchantFormat }[];

export const MERCHANT_CUTS = [
  { id: "Merchant", cut: "spot" },
  { id: "MerchantBumper", cut: "bumper" },
] as const;

export const b2cId = (lang: Lang, suffix: string) =>
  `B2C-${lang.toUpperCase()}${suffix}`;

export const b2bId = (lang: Lang, suffix: string) =>
  `B2B-${lang.toUpperCase()}${suffix}`;

export const merchantId = (cutId: string, lang: Lang, suffix: string) =>
  `${cutId}-${lang.toUpperCase()}-${suffix}`;
